import type { ReactNode } from "react"

import type { JsonObject } from "@/types/json"

import {
  SimulationWrapper,
  SimulationWrapperType,
  type SimulationWrapperConfig,
} from "../types"
import { CustomTestCaseCell } from "./CustomTestCaseCell"

export class CustomSimulationWrapper extends SimulationWrapper {
  constructor() {
    super({
      type: SimulationWrapperType.CUSTOM,
      name: "Custom",
      display_name: "Custom",
      metadata: {},
    })
  }

  render(): ReactNode {
    return (
      <div className="text-sm">
        <span className="font-medium">Custom</span>
      </div>
    )
  }

  renderTopLevelConfig(
    _config: SimulationWrapperConfig | null | undefined,
    _onConfigChange: (config: SimulationWrapperConfig) => void,
  ): ReactNode {
    return null
  }

  renderTestCaseCell(
    simulationMetadataInput: JsonObject | null | undefined,
    onUpdate: (updates: JsonObject) => void,
    isExpanded: boolean,
    width: string,
  ): ReactNode {
    return (
      <CustomTestCaseCell
        simulationMetadataInput={simulationMetadataInput}
        onUpdate={onUpdate}
        isExpanded={isExpanded}
        width={width}
      />
    )
  }
}
